import { classNames } from '../util/classNames';

type Props = React.HTMLProps<HTMLParagraphElement> & {
  variant?: 'base' | 'small';
  className?: string;
};

const PFParagraph = (props: Props) => {
  const { variant = 'base', className } = props;
  return (
    <p
      className={classNames(
        'py-3 px-0 ',
        variant === 'base' &&
          'leading-[30px] sm:text-[22px] sm:leading-[38px] child:sm:text-[22px] child:sm:leading-[38px]',
        variant === 'small' &&
          'text-[16px] child:text-[16px] leading-[24px] sm:text-[18px] sm:leading-[32px] child:sm:text-[18px] child:sm:leading-[32px]',
        className,
      )}
    >
      {props.children}
    </p>
  );
};

export default PFParagraph;
